<template>
  <div>
    <CrossswordCanvas 
      :fontFamily="fontFamily" 
      :bodyRender="bodyRender" 
      :letterPointsFontFamily="letterPointsFontFamily"
      @change="handleFileRender" 
    />
    <div class="scrabble-container__right__body">
      <div class="Abn-box-select-item">
        <div @click="handleFocusInput" :class="{ loading: loadingText }" class="scrabble__tag-input">
          <div class="scrabble__tags">
            <span v-for="(tag, index) in tags" :key="index" class="scrabble__tag">
              {{ tag }}
              <span class="scrabble__remove-tag" @click="removeTag(index)">✕
              </span>
            </span>
            <input class="scrabble__tag-input-text" type="text" ref="input" v-model="newTag" @keyup.enter="addTag"
              @keyup.space="addTag" @keydown="handleKeyDown" :placeholder="tags.length <= 0 ? 'Insert words' : ''"
              :disabled="loadingText" />
          </div>
          <div v-if="loadingText" class="group_path_text_layer_loading">
            <font-awesome-icon icon="spinner" class="fa-spin" />
          </div>
        </div>
        <p class="scrabble__tag-input__extra">
          <span class="error_scrabble" v-if="tags.length >= maxTags">
            You can add up to {{ maxTags }} tags only<br />
          </span>
          <span class="error_scrabble" v-if="errorsIndex.includes(4)">No letters in the word {{ newTagError }} exist in
            any other word.<br />
          </span>
          <span class="error_scrabble" v-if="errorsIndex.includes(1)">
            Only use alphabet characters (a-z, A-Z), DO NOT use numbers or special characters.<br />
          </span>
          <span class="error_scrabble" v-if="errorsIndex.includes(2)">
            For the same name, vary the capitalization i.e Ashley/ashLey.<br />
          </span>
          <span>
            <strong class="error_scrabble">*</strong> Separate names by typing space or enter.
          </span>
        </p>
      </div>
      <div v-if="backgroundScrabbleImages.length > 1" class="Abn-box-select-item background-scrabble">
        <label>{{ titleBackground }}</label>
        <div class="scrabble__select-img" :class="{ loading: loadingBg }">
          <div @click="() => handleChooseBackground(i)" :class="{ active: backgroundImage == i }"
            class="scrabble__select-img__item" v-for="(i, index) in backgroundScrabbleImages">
            <img width="100%" :src="i" />
            <div class="scrabble__select-img__item__checker" v-if="backgroundImage == i">
              <font-awesome-icon :class="{ 'fa-spin': loadingBg }" :icon="`${loadingBg ? 'spinner' : 'check-square'}`"
                style="font-size: 18px;color: #ff9100;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { get, debounce } from 'lodash';
import axios from 'axios';
import { ASSET_URL, AWS_API, URL_API_CROSSWORD_PUZZLE } from '../../config';
import CrossswordCanvas from '../Render/CrossswordCanvas.vue';
export default {
  name: 'ImageScrabble',
  data() {
    return {
      ChooseImageActive: false,
      imageRender: null,
      tags: [],
      newTag: '',
      newTagError: '',
      maxTags: 0,
      errorsIndex: [],
      loadingText: false,
      loadingBg: false,
      backgroundImage: null,
      isStart: false,
      bodyRender: {}
    }
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      default() {
        return null
      }
    },
    aspectRatio: {
      type: Number,
      default() {
        return 1
      }
    },
    width: {
      type: Number,
      default() {
        return 500
      }
    },
    height: {
      type: Number,
      default() {
        return 500
      }
    },
    configsScrabble: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    },
    valueDefault: {
      type: Object,
      required: true,
      default() {
        return {}
      }
    }
  },
  components: {
    CrossswordCanvas
  },
  watch: {
    tags() {
      this.handleRennder('text');
    },
    backgroundImage() {
      this.handleRennder('bg');
    },
    context(v) {
      const contextModel = v.model;
      if (contextModel.background) {
        this.backgroundImage = contextModel.background;
      }
      if (contextModel.tags) {
        this.tags = contextModel.tags;
      }
    },
  },
  created() {
    const { backgroundImage, tags, maxLength } = this.configsScrabble;
    this.backgroundImage = backgroundImage || '';
    this.tags = tags || [];
    this.maxTags = maxLength || 100000;
  },
  computed: {
    ...mapState(['cart_data']),
    titleBackground() {
      const { configsScrabble } = this;
      return get(
        configsScrabble,
        'titleBackground',
        'Crossword image puzzle background'
      )
    },
    backgroundScrabbleImages() {
      const { configsScrabble } = this;
      return get(configsScrabble, 'backgroundScrabbleImages', []);
    },
    modalName() {
      return `scrabble-${this.uniqueID(10)}`;
    },
    previewImage() {
      const { valueDefault, imageRender } = this;
      const getKeyImgDefault = get(valueDefault, 'file.key', null);
      const key = imageRender || getKeyImgDefault;
      return ASSET_URL + '/' + key;
    },
    localStorageName() {
      return this.context.name + '_' + this.product().id;
    },
    fontFamily() {
      const { configsScrabble } = this;
      return get(configsScrabble, 'fontFamily', null);
    },
    letterPointsFontFamily(){
      const { configsScrabble} = this;
      return get(configsScrabble, 'letterPointsFontFamily', null);
    }
  },
  methods: {
    ...mapMutations([
      'setCartDataByKey',
      'setMessageError',
      'setLoadingForm',
      'setIsSaveLocalstorage'
    ]),
    ...mapGetters(['product']),
    showCustomScrabble() {
      this.$modal.show(this.modalName);
    },
    uniqueID(length) {
      var result = ''
      var chars =
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)]
      return result;
    },
    handleChooseBackground(img) {
      this.isStart = true;
      this.setIsSaveLocalstorage(true);
      this.backgroundImage = img;
    },
    loadingEnabled(type) {
      switch (type) {
        case 'bg':
          this.loadingBg = true;
          break
        case 'text':
          this.loadingText = true;
          break
        default:
          break
      }
    },
    loadingDisabled(type) {
      switch (type) {
        case 'bg':
          this.loadingBg = false;
          break
        case 'text':
          this.loadingText = false;
          setTimeout(() => {
            this.$refs.input.focus();
          }, 200)
          break
        default:
          break
      }
    },
    handleFocusInput() {
      this.$refs.input.focus();
    },
    saveRoot(v) {
      this.setCartDataByKey(v);
    },
    handleRennder: debounce(async function (type) {
      const {
        tags,
        configsScrabble,
        backgroundImage,
        isStart,
        saveRoot,
        localStorageName,
        context,
        width,
        height
      } = this
      if (!isStart) return;
      if (tags.length > 1) {
        const body = {
          ...configsScrabble,
          tags,
          backgroundImage,
          width,
          height,
          type
        }
        await this.loadingEnabled(type);
        this.bodyRender = body;
      }
    }, 500),
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type)
      const put = await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      if (put.status === 200) {
        return {
          status: true,
          key: signedUrl.key
        }
      } else {
        return {
          status: false
        }
      }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(`${AWS_API}/signedUrl?type=${mime}`, requestOptions)
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    },
    async handleFileRender(data) {
      const { localStorageName } = this;
      const { base64, backgroundImage, tags, type } = data
      // const upfile = await this.upload(base64);
      // if (!upfile.status) {
      //   await this.loadingDisabled(type);
      //   return;
      // }
      // const { key } = upfile;
      const file = {
        id: this.context.name,
        // key: upfile.key,
        base64,
        background: backgroundImage,
        tags
      }
      this.context.model = file;
      this.saveRoot({
        key: localStorageName,
        name: this.context.label,
        value: {
          background: backgroundImage,
          tags
        }
         //ASSET_URL + '/' + key // query.key
      });
      await this.loadingDisabled(type);
    },
    handleCancel() {
      this.$modal.hide(this.modalName);
    },
    hideModal() {
      this.$modal.hide(this.modalName);
    },
    isValidTag(tag) {
      return /^[a-zA-Z]+$/.test(tag);
    },
    hasCommonCharacter(arr) {
      const charSets = arr.map(item => new Set(item.toLowerCase()))
      for (let i = 0; i < charSets.length - 1; i++) {
        for (let j = i + 1; j < charSets.length; j++) {
          for (let char of charSets[i]) {
            if (charSets[j].has(char)) {
              return true;
            }
          }
        }
      }
      return false;
    },
    addTag() {
      this.isStart = true;
      this.setIsSaveLocalstorage(true);
      const trimmedTag = this.newTag.trim();
      const newTags = [...this.tags, trimmedTag];
      if (!this.isValidTag(trimmedTag)) {
        this.errorsIndex = [...this.errorsIndex, 1];
      } else {
        this.errorsIndex = this.errorsIndex.filter(i => i != 1);
      }

      if (this.tags.includes(trimmedTag)) {
        this.errorsIndex = [...this.errorsIndex, 2];
      } else {
        this.errorsIndex = this.errorsIndex.filter(i => i != 2);
      }
      if (!this.hasCommonCharacter(newTags) && newTags.length == 2) {
        this.errorsIndex = [...this.errorsIndex, 4];
        this.newTagError = trimmedTag;
      } else {
        this.errorsIndex = this.errorsIndex.filter(i => i != 4)
      }
      if (this.errorsIndex.length <= 0 && this.tags.length < this.maxTags) {
        this.tags.push(trimmedTag);
        this.newTag = '';
      }
    },
    removeTag(index) {
      this.tags.splice(index, 1);
      this.isStart = true;
      this.setIsSaveLocalstorage(true);
    },
    handleKeyDown(event) {
      if (
        (event.key === 'Backspace' || event.key === 'Delete') &&
        !this.newTag &&
        this.tags.length > 0
      ) {
        this.removeTag(this.tags.length - 1);
      }
    },
    async upload(base64) {
      var file = await fetch(base64)
        .then(res => res.arrayBuffer())
        .then(buf => new File([buf], 'tmp.png', { type: 'image/png' }))
      var signedUrl = await this.getSignedUrl(file.type);
      const put = await axios
        .put(signedUrl.url, file, {
          headers: {
            'Content-Type': file.type
          }
        })
        .catch(err => console.error(err))
      if (put.status === 200) {
        return {
          status: true,
          key: signedUrl.key
        }
      } else {
        return {
          status: false
        }
      }
    },
    async getSignedUrl(mime) {
      var headers = new Headers()
      headers.append('Content-Type', 'application/json')
      var requestOptions = {
        method: 'GET',
        headers: headers,
        redirect: 'follow'
      }
      var signedUrl = null
      await fetch(
        `${this.$options.AWS_API}/signedUrl?type=${mime}`,
        requestOptions
      )
        .then(response => response.json())
        .then(res => (signedUrl = res))
        .catch(err => console.error(err))
      return signedUrl
    }
  }
}
</script>

<style>
.v-ion-abn {
  width: 16px;
  padding: 0;
  margin: 0;
  margin-right: 5px;
}

.btn-chooser-scrabble {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_scrabble {
  z-index: 999999 !important;
  overflow: auto;
}

.modal_scrabble>div::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}

.modal_scrabble>div::-webkit-scrollbar-thumb {
  background-color: #341a1a;
}

.scrabble-container__right__body {
  height: 100%;
  overflow: auto;
}

.Abn-box-select-item {
  margin-top: 0px;
  margin-bottom: 0px;
}

.Abn-box-select-item>h5 {
  font-size: 16px;
  font-weight: 700;
}

.scrabble__tag-input {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #ccc;
  padding: 3px;
  border-radius: 4px;
  background: #fff;
  position: relative;
}

.scrabble__tag-input.loading,
.scrabble__select-img.loading {
  opacity: 0.8;
  pointer-events: none;
}

.scrabble__tags {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.scrabble__tag {
  display: flex;
  align-items: center;
  background-color: #e0e0e0;
  border-radius: 3px;
  padding: 2px 8px;
  margin: 2px;
  line-height: 1.5;
  height: 28px;
  font-family: system-ui;
  font-weight: 400;
}

.scrabble__remove-tag {
  cursor: pointer;
  margin-left: 5px;
  font-weight: bold;
  line-height: 1px;
}

.scrabble__tag-input-text {
  border: none;
  outline: none;
  flex: 1;
  min-width: 100px;
  background: none;
  box-shadow: none !important;
  border: none !important;
  height: 30px !important;
  margin-bottom: 0 !important;
  padding: 0px 2px !important;
}

.error_scrabble {
  color: red;
}

button.btn.Abn-btn-cancel {
  background: #7b7b7e !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

button.btn.Abn-btn-apply {
  background: none 0% 0% / auto repeat scroll padding-box border-box rgb(33 171 43) !important;
  color: white !important;
  font-weight: 600 !important;
  width: 49%;
  float: left;
}

.scrabble__tag-input__extra {
  color: #3b3b3b;
  font-size: 14px;
  font-style: italic;
  margin-top: 5px;
  margin-bottom: 0;
}

.scrabble__select-img {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  overflow: auto;
  margin-bottom: 0px;
  scroll-snap-type: x;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.scrabble__select-img>* {
  scroll-snap-type: x;
  scroll-snap-align: start;
  scroll-snap-stop: always;
}

.scrabble__select-img::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

.scrabble__select-img::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  border-radius: 10px;
  background-color: #f5f5f5;
}

.scrabble__select-img::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #555;
}

.scrabble__select-img__item {
  width: 70px;
  min-width: 70px;
  height: 70px;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  margin-bottom: 5px;
  border-radius: 5px;
  overflow: hidden;
  background: #e7e7e7;
  cursor: pointer;
  position: relative;
}

.scrabble__select-img__item.active {
  padding: 0px;
  border: 2px solid #d26e4b;
}

.scrabble__select-img__item__checker {
  position: absolute;
  bottom: 5px;
  right: 5px;
  height: 18px;
  width: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.Abn-box-select-item.background-scrabble {
  margin-top: 20px;
}

.group_path_text_layer_loading {
  position: absolute;
  top: 0;
  background: #00000008;
  bottom: 0;
  left: 0;
  right: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-end;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: flex-end;
  padding: 10px 12px;
  border-radius: 5px;
  cursor: not-allowed;
  color: #636363;
}

@media only screen and (max-width: 739px) {
  .modal_scrabble>div {
    padding: 0px 10px;
  }

  .modal_scrabble .vm--modal {
    top: 0px !important;
    height: 100vh !important;
    bottom: 0 !important;
    background: white !important;
    padding: 0px !important;
    z-index: 999999;
    overflow: hidden !important;
  }

  .Abn-box-select-item {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }

  .Abn-box-select-item>h5 {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Formulate/ImageScrabble.vue